export default class UserAgent {
  static ua() {
    const u = window.navigator.userAgent.toLowerCase();

    return {
      tablet: (u.indexOf("windows") !== -1 && u.indexOf("touch") !== -1 && u.indexOf("tablet pc") === -1)
        || u.indexOf("ipad") !== -1
        || (u.indexOf("android") !== -1 && u.indexOf("mobile") === -1)
        || (u.indexOf("firefox") !== -1 && u.indexOf("tablet") !== -1)
        || u.indexOf("kindle") !== -1
        || u.indexOf("silk") !== -1
        || u.indexOf("playbook") !== -1,
      mobile: (u.indexOf("windows") !== -1 && u.indexOf("phone") !== -1)
        || u.indexOf("iphone") !== -1
        || u.indexOf("ipod") !== -1
        || (u.indexOf("android") !== -1 && u.indexOf("mobile") !== -1)
        || (u.indexOf("firefox") !== -1 && u.indexOf("mobile") !== -1)
        || u.indexOf("blackberry") !== -1,
      android: u.indexOf("android") !== -1,
      ios: u.indexOf("iphone") !== -1 || u.indexOf("ipod") !== -1,
      chrome: u.indexOf("chrome") !== -1
    };
  }
}

export const isPC = () => {
  const ua = UserAgent.ua();
  return !ua.tablet && !ua.mobile;
};

export const isNotPC = () => {
  return !isPC();
};

export const isIOS = () => {
  const ua = UserAgent.ua();
  return ua.ios;
};

export const isAndroid = () => {
  const ua = UserAgent.ua();
  return ua.android;
};

export const isChrome = () => {
  const ua = UserAgent.ua();
  return ua.chrome;
};



// WEBPACK FOOTER //
// ./src/js/modules/ua.js